<template>
  <div class="information" @click="gotoEdit">
    <div class="col1">
      <van-image class="avatarImg" :src="imgUrlFilter(userData.HeadImg)">
        <template v-slot:error>
          <img
            class="userImg"
            src="~assets/img/userManage/img_logo@2x.png"
          /> </template
      ></van-image>
    </div>
    <div class="col2">
      <div class="row2">
        <span class="label">{{ $t.auth.username }}</span
        ><span class="txt">{{ userData.UserName }}</span>
      </div>
      <div class="row2">
        <span class="label">{{ $t.auth.role }}</span
        ><span class="txt">{{ userData.RoleName }}</span>
      </div>
    </div>
    <div class="col3">
      <van-image class="iconImg" :src="edit"></van-image>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image } from "vant";
Vue.use(Image);
export default {
  name: "Information",
  props: {
    userData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      edit: require("@/assets/img/home/edit.png"),
    };
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    gotoEdit() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "myInfo",
        name: "myInfo",
        query: [],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.information {
  color: #0e78a6;
  padding: 3% 0;
  border-bottom: 1px solid #ebedf0;
}
.col1 {
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  width: 25%;
  .avatarImg {
    width: 50px;
    height: 50px;
    .userImg {
      width: 50px;
      height: 50px;
      object-fit: contain;
      border-radius: 100%;
    }
    ::v-deep .van-image__error {
      border-radius: 100%;
      position: block;
    }
    ::v-deep .van-image__img {
      object-fit: contain;
      border-radius: 100px;
    }
  }
}
.col2 {
  margin-top: 5px;
  vertical-align: middle;
  display: inline-block;
  width: 65%;
  font-size: 12px;
  .row2 {
    font-weight: bold;
    line-height: 20px;
    margin-bottom: 5px;
    overflow: hidden;
    .label {
      line-height: 18px;
      display: inline-block;
      color: #000;
      vertical-align: middle;
    }
    .txt {
      line-height: 18px;
      margin-left: 10px;
      color: #0e78a6;
      font-weight: normal;
      vertical-align: middle;
      display: inline-block;
    }
  }
  .iconImg {
    width: 18px;
    height: 18px;
    margin-right: 3px;
    margin-left: 3px;
    object-fit: contain;
    vertical-align: middle;
  }
}
.col3 {
  text-align: left;
  vertical-align: top;
  display: inline-block;
  width: 10%;
  .iconImg {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 5px;
    vertical-align: middle;
  }
}
</style>
